import { getConfig } from "./config"
import { getSessionsByEnvironment } from "./storage/sessionStorage"

export const getSessions = async () => {
  const { environment } = await getConfig()
  return getSessionsByEnvironment(environment)
}
